<div class="errorpage-content col-lg-6 offset-lg-3">
  <h1>{{ 'error.page.title' | translate }}</h1>
  <div class="error-text" [ishServerHtml]="'error.page.text' | translate"></div>
  <div class="search-container error-search-container">
    <div *ishNotFeature="'sparqueSearch'">
      <custom-search-box
        [configuration]="{
          placeholder: 'search.searchbox.instructional_text' | translate,
          autoSuggest: true,
          maxAutoSuggests: 10
        }"
      />
    </div>
    <div *ishFeature="'sparqueSearch'">
      <ish-search-box
        [configuration]="{
          placeholder: 'search.searchbox.instructional_text' | translate,
          maxAutoSuggests: 10
        }"
      />
    </div>
  </div>
</div>
